import type { InteractiveQuestionBankInteractiveQuestion } from '@genially/contracts';
import { GeneratedInteractiveQuestionType } from '@genially/contracts';
import { getTrueFalseBankAnswerTexts } from '@genially/ui';

// Bank answer options have no persisted id of their own — the view player
// derives one deterministically as `${bankQuestionId}__${index}` (see
// adaptBankQuestion.ts / buildResolvedRandomQuestion.ts) and that derived id
// is what ends up in the user's answerIds/userAnswer. Decode it back to an
// index into the bank question's own `answers` array.
export const bankAnswerIndexFromId = (answerId: string): number => {
  const separatorIndex = answerId.lastIndexOf('__');

  if (separatorIndex === -1) {
    return -1;
  }

  const index = Number(answerId.slice(separatorIndex + 2));

  return Number.isNaN(index) ? -1 : index;
};

export const bankAnswerTextFromId = (
  bankQuestion: InteractiveQuestionBankInteractiveQuestion,
  answerId: string,
  t: (key: string) => string,
): string | undefined => {
  const index = bankAnswerIndexFromId(answerId);

  if (index < 0) {
    return undefined;
  }

  switch (bankQuestion.type) {
    case GeneratedInteractiveQuestionType.FillInTheBlanks:
      return bankQuestion.answers[index];

    case GeneratedInteractiveQuestionType.TrueFalse:
      return getTrueFalseBankAnswerTexts(bankQuestion, [
        t('__new.shared.content.interactiveQuestionTrue'),
        t('__new.shared.content.interactiveQuestionFalse'),
      ])[index];

    case GeneratedInteractiveQuestionType.QuizSingleChoice:
    case GeneratedInteractiveQuestionType.QuizMultipleChoice:
    case GeneratedInteractiveQuestionType.Sort:
    case GeneratedInteractiveQuestionType.ShortAnswer:
      return bankQuestion.answers[index]?.text;

    default:
      return undefined;
  }
};
